module.exports = __webpack_public_path__ + "img/linyiwei.a501284e.jpg";